import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const cache = new Map();

export function useTenantBrand(token) {
  const [tenant, setTenant] = useState(() => cache.get(token) || null);
  useEffect(() => {
    if (!token || cache.has(token)) return;
    api.get(`/invite/${token}`).then(r => {
      const t = r.data?.tenant || null;
      cache.set(token, t);
      setTenant(t);
    }).catch(() => {});
  }, [token]);
  return tenant;
}

export function BrandMark({ tenant, light = false }) {
  if (!tenant?.name) return null;
  return (
    <div className="flex items-center gap-2.5 min-w-0" data-testid="candidate-brand">
      {tenant.logo_data_url ? (
        <span className={`inline-flex items-center rounded-md px-1.5 py-1 ${light ? "" : "bg-white"}`}>
          <img src={tenant.logo_data_url} alt={tenant.name} className="h-6 max-w-[120px] object-contain" data-testid="candidate-brand-logo" />
        </span>
      ) : (
        <span className="w-7 h-7 shrink-0 rounded-md bg-indigo-600 grid place-items-center text-white font-bold text-sm" data-testid="candidate-brand-initial">{tenant.name[0].toUpperCase()}</span>
      )}
      <span className={`font-display font-semibold text-sm truncate ${light ? "text-slate-900" : "text-slate-100"}`} data-testid="candidate-brand-name">{tenant.name}</span>
    </div>
  );
}

export function BrandBar({ tenant, label }) {
  return (
    <div className="h-10 shrink-0 border-b border-[color:var(--bd-sub)] px-6 flex items-center justify-between gap-4" data-testid="candidate-brand-bar">
      <BrandMark tenant={tenant} />
      <div className="text-[11px] uppercase tracking-wider text-slate-500 shrink-0">{label}</div>
    </div>
  );
}

export function PoweredBy({ light = false }) {
  return (
    <div className={`py-3 text-center text-[11px] ${light ? "text-slate-400" : "text-slate-600"}`} data-testid="powered-by">
      Powered by <span className="font-semibold">RecruitSift</span>
    </div>
  );
}
